export enum DriftLoadStates {
	PENDING_CONSENT = 'pending-consent',
	CONSENT_PROVIDED = 'consent-provided',
	LOADED = 'loaded',
	INITIALIZED = 'initialized'
}
